import head from 'lodash/head'
import last from 'lodash/last'
import perMeterCalc from './perMeterCalc'

export function calcWidthHeightSet(sets, perMeter) {
  const frames = sets
    .map(({ width, height, x = 0, y = 0, ...set }) => ({
      ...set,
      width: Number(perMeterCalc(width, perMeter)),
      height: Number(perMeterCalc(height, perMeter)),
      x: Number(perMeterCalc(x, perMeter)),
      y: Number(perMeterCalc(y, perMeter)),
    }))
    .map(({ y = 0, ...set }, index) => ({
      ...set,
      y: index === 0 ? Number(y) : Number(y) === 0 ? perMeterCalc(sets[index - 1].height, perMeter) : Number(y),
    }))

  const minimumW = takeFirst(frames, set => set.x)
  const maximumW = takeLatest(frames, set => set.x + set.width)

  const minimumH = takeFirst(frames, set => set.y)
  const maximumH = takeLatest(frames, set => set.y + set.height)

  return {
    width: maximumW - minimumW,
    height: maximumH - minimumH,
  }
}

function takeFirst(array, cb) {
  return head(array.map(cb).sort(sortNumber))
}

function takeLatest(array, cb) {
  return last(array.map(cb).sort(sortNumber))
}

function sortNumber(a, b) {
  return Number(a) !== Number(b) ? (Number(a) > Number(b) ? 1 : -1) : 0
}



// WEBPACK FOOTER //
// ./src/utils/calcFrame.js